import React, { useMemo } from 'react';
import { graphql } from 'gatsby';
import { className, Text, Heading, Card } from 'design-system';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useTranslate } from 'gatsby-theme-soluble-source';
import style from './style.module.scss';
import ButtonComponent from '../ButtonComponent';
import TeamMeberSocialIcons from '../TeamMemberSocialIcons';

export default function CardPerson({
    image,
    name,
    teamMemberPosition,
    linkedin,
    email,
}) {
    const translation = useTranslate();

    const externalLink = useMemo(() => {
        if (linkedin) {
            return linkedin;
        }

        return email ? `mailto:${email}` : null;
    }, [linkedin, email]);

    return (
        <Card
            wrapperClassName={`${style.card}`}
            bodyClassName={style['card__body']}>
            {image?.gatsbyImageData ? (
                <div {...className(`${style.imageContainer} mb-3`)}>
                    <GatsbyImage image={image.gatsbyImageData} alt={name} />
                </div>
            ) : null}
            <Heading tag="h5" className="body text-uppercase font-weight-bold">
                {name}
            </Heading>
            {teamMemberPosition ? (
                <Text className="body" tag="p">
                    {teamMemberPosition}
                </Text>
            ) : null}
            <TeamMeberSocialIcons linkedin={linkedin} email={email} />
            {externalLink ? (
                <ButtonComponent
                    button={{
                        type: 'secondary',
                        externalLink,
                        target: '_blank',
                        label: translation['post.responsable.contact'].text,
                    }}
                />
            ) : null}
        </Card>
    );
}

export const query = graphql`
    fragment CardPerson on DatoCmsTeamMember {
        name
        teamMemberPosition
        linkedin
        email
        image {
            gatsbyImageData(
                placeholder: BLURRED
                layout: FIXED
                imgixParams: { w: "80", h: "80", fit: "crop" }
            )
        }
    }
`;
